var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnhanceProductivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 42.4264,
    width: 59,
    height: 39,
    rx: 19.5,
    transform: "rotate(-45 0.707107 42.4264)",
    fill: "#F3FAFF",
    stroke: "#CEECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 41.5H33.3333C30.5833 41.5 29.2083 41.5 28.3542 40.6458C27.5 39.7917 27.5 38.4167 27.5 35.6667V26.5",
    stroke: "#175677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6641 38.1658C34.6074 38.1658 40.7599 36.9458 40.5807 29.3608M38.7407 30.7025L40.3099 29.1216C40.3482 29.083 40.3937 29.0523 40.4439 29.0312C40.4941 29.0102 40.5479 28.9993 40.6023 28.999C40.6567 28.9988 40.7106 29.0093 40.761 29.0299C40.8113 29.0505 40.8571 29.0808 40.8957 29.1191L42.4974 30.7025",
    stroke: "#175677",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceProductivity);
export default __webpack_public_path__ + "static/media/Enhance Productivity.3314e03e70dcfaad84b6c110f2766062.svg";
export { ForwardRef as ReactComponent };